import { Icon } from '@virtidev/toolbox';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePrevious } from '../../../../../utility/CustomHooks';
import {
  isFullscreenSelector,
  setFullscreen,
} from '../../slices/vh-player/VHPlayerSlice';
import * as Styled from './FullscreenVHButton.styled';

const FullscreenVHButton = () => {
  const dispatch = useDispatch();
  const fullscreen = useSelector(isFullscreenSelector);

  const handleFullscreenClick = useCallback(() => {
    dispatch(setFullscreen(!fullscreen));
  }, [dispatch, fullscreen]);

  return (
    <Styled.FullscreenButton onClick={handleFullscreenClick}>
      <Styled.InnerContent>
        <Icon
          icon={fullscreen ? 'exit-fullscreen' : 'fullscreen'}
          iconType="outline"
          size="18px"
        />
      </Styled.InnerContent>
    </Styled.FullscreenButton>
  );
};

export default FullscreenVHButton;
